import React from 'react';

interface ITimePickerComponentProps {
    value?: string;
    onChange: (value: string) => void;
    disabled?: boolean;
};

const TimePickerComponent = (props: ITimePickerComponentProps) => {
    const onChangeTime = (e: any) : void => {
        props.onChange(e.target.value);
    };

    return (
        <input 
            type="time"
            disabled={props.disabled}
            value={props.value}
            onChange={onChangeTime}
            placeholder="Horas y minutos hh:mm"
            style={{
                paddingTop: 3.5,
                paddingBottom: 3.5,
                width: '100%',
                textAlign: 'center',
                fontSize: 14,
                fontWeight: 400,
            }} />
    );
};

export default TimePickerComponent;
